module.exports = __webpack_public_path__ + "img/phone-folkentinget.a6e08bba.png";